var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 10.5267C3.5 5.92688 7.34388 2.20898 11.9934 2.20898C16.6561 2.20898 20.5 5.92688 20.5 10.5267C20.5 12.8447 19.657 14.9966 18.2695 16.8206C16.7388 18.8325 14.8522 20.5854 12.7285 21.9614C12.2425 22.2794 11.8039 22.3034 11.2704 21.9614C9.13474 20.5854 7.24809 18.8325 5.7305 16.8206C4.34198 14.9966 3.5 12.8447 3.5 10.5267ZM9.19423 10.7857C9.19423 12.3267 10.4517 13.5387 11.9934 13.5387C13.5362 13.5387 14.8058 12.3267 14.8058 10.7857C14.8058 9.25678 13.5362 7.98582 11.9934 7.98582C10.4517 7.98582 9.19423 9.25678 9.19423 10.7857Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.540897d9a31233cfad1dfe24f91e074c.svg";
export { ForwardRef as ReactComponent };